import { ProjectEditPage } from './ProjectEditPage'
import { ProjectEditDialog } from './ProjectEditDialog'
import { ProjectEditDialogConfig } from '../../hooks/projectEditDialogData'

type Props = {
  code?: string
  functionLayerDepth?: number
  // FunctionLayer 上でダイアログとして開く場合に渡される設定。
  auxiliaries?: {
    projectEditDialog?: ProjectEditDialogConfig
  }
  // LayerDialog が渡す閉じる導線（confirmClose）。
  onRequestClose?: () => void
}

// PROJECT_REGISTRATION のエントリ。auxiliaries.projectEditDialog の有無で
// 通常のページ（DB保存）か、ダイアログ版（遅延保存）かを振り分ける。
export const ProjectEdit = ({ code, auxiliaries }: Props) => {
  const dialog = auxiliaries?.projectEditDialog
  if (dialog) {
    return <ProjectEditDialog dialog={dialog} />
  }
  return <ProjectEditPage code={code} />
}
